import { MaintenanceItemStatus, type MaintenanceItem } from "@/supabase.types";
import { groupBy } from "@/utils/format";

import type { MaintenanceItemsStatusProgressDetails } from "@/api/resources/maintenancesToDevices/types";

export const defaultMaintenanceItemsStatusProgressDetails: MaintenanceItemsStatusProgressDetails = {
  [MaintenanceItemStatus.pending]: 0,
  [MaintenanceItemStatus.started]: 0,
  [MaintenanceItemStatus.skipped]: 0,
  [MaintenanceItemStatus.failed]: 0,
  [MaintenanceItemStatus.completed]: 0,
};

export const getMaintenanceItemsStatusProgress = (
  statusProgressDetails: MaintenanceItemsStatusProgressDetails,
): number => {
  return statusProgressDetails.completed + statusProgressDetails.failed + statusProgressDetails.skipped;
};

export const getMaintenanceItemsStatusProgressDetails = (
  maintenanceItems: Pick<MaintenanceItem, "status">[],
): MaintenanceItemsStatusProgressDetails => {
  const byStatus = groupBy(maintenanceItems, "status", {
    [MaintenanceItemStatus.pending]: [],
    [MaintenanceItemStatus.started]: [],
    [MaintenanceItemStatus.skipped]: [],
    [MaintenanceItemStatus.failed]: [],
    [MaintenanceItemStatus.completed]: [],
  });

  return {
    [MaintenanceItemStatus.pending]: byStatus[MaintenanceItemStatus.pending].length,
    [MaintenanceItemStatus.started]: byStatus[MaintenanceItemStatus.started].length,
    [MaintenanceItemStatus.skipped]: byStatus[MaintenanceItemStatus.skipped].length,
    [MaintenanceItemStatus.failed]: byStatus[MaintenanceItemStatus.failed].length,
    [MaintenanceItemStatus.completed]: byStatus[MaintenanceItemStatus.completed].length,
  };
};
